import { mergeToNewObject } from '../../../util/helpers'
import { TC_ACTIONS, BRANDING_ACTIONS } from '../../../constants/actions'

export const authReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case TC_ACTIONS.ON_GET_POLICY_FROM_STORAGE:
      return mergeToNewObject(state, { policyAccepted: payload.policy })

    case TC_ACTIONS.ON_TC_ACCEPTED:
      return mergeToNewObject(state, { policyAccepted: true })

    case BRANDING_ACTIONS.ON_STORE_BRAND_SYMBOL:
      return mergeToNewObject(state, { brandingSymbol: payload })

    case BRANDING_ACTIONS.ON_FINISH_LOADING:
      return mergeToNewObject(state, { loading: false })

    case BRANDING_ACTIONS.ON_BRAND_DATA_RECEIVED:
      return mergeToNewObject(state, {
        brandData: payload,
        loading: false
      })

    case BRANDING_ACTIONS.ON_BRAND_DATA_NO_DATA:
      return mergeToNewObject(state, {
        loading: false,
        brandingSymbol: '',
        brandData: {}
      })

    default:
      return state
  }
}

const INITIAL_STATE = {
  policyAccepted: true,
  loading: true,
  brandingSymbol: '',
  brandData: {
    // name,
    // redirect
    // symbol
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/auth/index.js